// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-svg-icon, svg-icon {
  line-height: 1em;
  vertical-align: middle;
}
motes-svg-icon svg, svg-icon svg {
  font-size: inherit;
  display: inline-block;
  fill: currentColor;
  stroke: currentColor;
  width: 1em;
  height: 1em;
  overflow: visible;
}
motes-svg-icon .icon-not-found, svg-icon .icon-not-found {
  font-size: 12px;
}
motes-svg-icon .svg-drop-shadow-dark svg, svg-icon .svg-drop-shadow-dark svg {
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.7));
}
motes-svg-icon .svg-drop-shadow-light svg, svg-icon .svg-drop-shadow-light svg {
  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.7));
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/svg-icon/svg-icon.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,sBAAA;AACJ;AACI;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;AACR;AACI;EACI,eAAA;AACR;AACI;EAEI,+CAAA;AACR;AACI;EAEI,qDAAA;AACR","sourcesContent":["motes-svg-icon, svg-icon {\n    line-height: 1em;\n    vertical-align: middle;\n    \n    svg {\n        font-size: inherit;\n        display: inline-block;\n        fill: currentColor;\n        stroke: currentColor;\n        width: 1em;\n        height: 1em;\n        overflow: visible;\n    }\n    .icon-not-found {\n        font-size: 12px;\n    }\n    .svg-drop-shadow-dark svg {\n        -webkit-filter: drop-shadow(0 0 5px rgba(0, 0, 0, .7));\n        filter: drop-shadow(0 0 5px rgba(0, 0, 0, .7));\n    }\n    .svg-drop-shadow-light svg {\n        -webkit-filter: drop-shadow(0 0 5px rgba(255, 255, 255, .7));\n        filter: drop-shadow(0 0 5px rgba(255, 255, 255, .7));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
